<template>
  <basic-container>
    <div
      class="path-container"
      style="margin-bottom: 20px; padding: 10px 15px; border-radius: 4px"
    >
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>客服工作站</el-breadcrumb-item>
        <el-breadcrumb-item>工单与问题跟踪</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <avue-crud
      :option="option"
      :data="data"
      ref="crud"
      v-model="form"
      :page.sync="page"
      @refresh-change="refreshChange"
      @search-change="searchChange"
      @search-reset="searchReset"
      @selection-change="selectionChange"
      @on-load="(page) => onLoad(page, params)"
      @row-save="saveIssue"
      @row-update="updateIssue"
      @row-del="deleteWorkIssue"
      :header-cell-class-name="headerCellClassName"
    >
      <template slot="menuLeft"> </template>
    </avue-crud>
  </basic-container>
</template>

<script>
import {
  getWorkIssue,
  saveOrUpdateWorkIssue,
  deleteWorkIssue,
} from "@/api/health/manage";
import { getDetail, remove, enable, disable } from "@/api/health/userjk";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      params: {
        channel: window.localStorage.getItem("channel"),
      },
      form: {},
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      selectionList: [],
      headerCellClassName: 'headerClass',
      option: {
        tip: false,
        border: false,
        index: true,
        indexLabel: "序号",
        viewBtn: true,
        editBtn: true,
        addBtn: true,
        addBtnText: "新 增 数 据",
        delBtn: true,
        selection: true,
        searchSpan: 4,
        searchEnter: true,
        searchMenuSpan: 4,
        column: [
          {
            label: "工单ID",
            prop: "id",
            search: true,
            editDisabled: true,
            addDisabled: true,
            width: 170
          },
          {
            label: "问题类型",
            prop: "type",
            search: true,
            type: "select",
            dicData: [
              { label: "操作疑问", value: 0 },
              { label: "设备故障", value: 1 },
              { label: "权益问题", value: 2 },
            ],
          },
          {
            label: "处理状态",
            prop: "status",
            search: true,
            type: "select",
            dicData: [
              { label: "待处理", value: 0 },
              { label: "处理中", value: 1 },
              { label: "已解决", value: 2 },
            ],
          },
          {
            label: "优先级",
            prop: "priority",
            search: true,
            type: "select",
            dicData: [
              { label: "普通", value: 0 },
              { label: "紧急", value: 1 },
            ],
          },
          {
            label: "用户反馈",
            prop: "record",
            overHidden: true,
          },
          {
            label: "处理人员",
            prop: "staff",
            // type: "select",
            search: true,
          },
          {
            label: "解决时间",
            prop: "resoltTime",
            editDisabled: true,
            addDisabled: true,
            formatter: (row) => {
              if (row.status === 2) return row.resoltTime;
              else return "";
            },
          },
        ],
      },
      data: [],
    };
  },
  computed: {
    ...mapGetters(["permission"]),
    permissionList() {
      return {
        addBtn: this.permission.health_userjk_add,
        viewBtn: this.permission.health_userjk_view,
        delBtn: this.permission.health_userjk_delete,
        editBtn: this.permission.health_userjk_edit,
      };
    },
    ids() {
      const ids = [];
      this.selectionList.forEach((ele) => {
        ids.push(ele.id);
      });
      return ids.join(",");
    },
  },

  methods: {
    onLoad(page, params) {
      params.channel = window.localStorage.getItem("channel");
      console.log("onload? ");
      getWorkIssue(page.currentPage, page.pageSize, params).then((res) => {
        this.page.total = res.data.total;
        this.data = res.data.issues;
      });
    },

    saveIssue(row, done, loading) {
      row.channel = window.localStorage.getItem("channel");
      saveOrUpdateWorkIssue(row)
        .then((res) => {
          done();
          this.onLoad(this.page, this.params);
          this.$message.success("添加成功!");
        })
        .catch(() => {
          this.onLoad(this.page, this.params);
        });
    },

    updateIssue(row, index, done, loading) {
      // row.channel = window.localStorage.getItem("channel");
      if (row.id == null) {
        done();
        this.$message.success("数据未修改!");
        return;
      }
      saveOrUpdateWorkIssue(row)
        .then((res) => {
          done();
          this.onLoad(this.page, this.params);
          this.$message.success("修改成功!");
        })
        .catch(() => {
          this.onLoad(this.page, this.params);
        });
    },

    deleteWorkIssue(row, index, done, loading) {
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return deleteWorkIssue(row);
        })
        .then(() => {
          this.onLoad(this.page, this.params);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        });
    },

    searchChange(params, done) {
      console.log("SeachChange?");
      params.channel = window.localStorage.getItem("channel");
      this.params = params;
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },

    searchReset() {
      this.params = {
        channel: window.localStorage.getItem("channel"),
      };
      this.page.currentPage = 1;
      this.onLoad(this.page, this.params);
    },

    selectionChange(list) {
      this.selectionList = list;
    },

    refreshChange(data) {
      this.onLoad(this.page, data.searchForm);
    },

    handleDelete() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return remove(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.$refs.crud.toggleSelection();
        });
    },

    handleEnable() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定对该用户启用VIP嘛?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return enable(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.$refs.crud.toggleSelection();
        });
    },

    handleDisable() {
      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }
      this.$confirm("确定对该用户停用VIP嘛?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return disable(this.ids);
        })
        .then(() => {
          this.onLoad(this.page);
          this.$message({
            type: "success",
            message: "操作成功!",
          });
          this.$refs.crud.toggleSelection();
        });
    },

    beforeOpen(done, type) {
      if (["edit", "view"].includes(type)) {
        getDetail(this.form.id).then((res) => {
          this.form = res.data;
        });
      }
      done();
    },

    archiveType(row) {
      console.log(row);
      const parameter = {
        wxUserId: row.wxUserId,
      };
      this.$router.push({
        path: "/health/archiveType",
        query: parameter,
      });
    },

    handleDetail(data) {
      this.$router.push({
        path: "/health/bpmeterdata_detail",
        query: {
          wxUserId: data.id,
          meterDate: this.params.meterDate,
          jkStatus: data.jkStatus,
        },
      });
    },

    datashow(row) {
      const parameter = {
        wxUserId: row.wxUserId,
      };
      this.$router.push({
        path: "/customer/datashow",
        query: parameter,
      });
    },
  },
};
</script>

<style>
/* 表头居中 */
.avue-crud .el-table__header th .cell {
  font-size: 14px !important;
  text-align: center !important;
}

/* 单元格内容字体大小 */
.el-table__body td {
  font-size: 14px !important;
  text-align: center !important;
}
.headerClass{
      background-color: #409EFF !important;
      color:#FFF !important;
    }
</style>
